import { ShopByPlateModal } from 'components/VehicleConfigurator'

export default ShopByPlateModal
